import { cn } from "@/lib/utils";

const STATE_CONFIG = {
  // Event statuses
  rascunho: { label: "Rascunho", color: "gray" },
  a_contactar: { label: "A contactar", color: "yellow" },
  parcialmente_preenchido: { label: "Parcial", color: "yellow" },
  confirmado: { label: "Confirmado", color: "green" },
  concluido: { label: "Concluído", color: "green" },
  cancelado: { label: "Cancelado", color: "red" },
  // Request statuses
  enviado: { label: "Enviado", color: "gray" },
  visto: { label: "Visto", color: "gray" },
  disponivel: { label: "Disponível", color: "green" },
  indisponivel: { label: "Indisponível", color: "red" },
  sem_resposta: { label: "Sem resposta", color: "yellow" },
  expirado: { label: "Expirado", color: "gray" },
  removido: { label: "Removido", color: "gray" },
};

const COLOR_CLASSES = {
  green: "bg-emerald-100 text-emerald-800 border-emerald-200",
  red: "bg-red-100 text-red-800 border-red-200",
  yellow: "bg-amber-100 text-amber-800 border-amber-200",
  gray: "bg-zinc-100 text-zinc-700 border-zinc-200",
};

export default function StateBadge({ status, className }) {
  const cfg = STATE_CONFIG[status] || { label: status, color: "gray" };
  return (
    <span
      data-testid={`state-badge-${status}`}
      className={cn(
        "inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium border whitespace-nowrap",
        COLOR_CLASSES[cfg.color],
        className,
      )}
    >
      {cfg.label}
    </span>
  );
}
